import { Permissions } from "@/common/enums/sharedEnums";
import { IAgency } from "@/modules/profile/interfaces/agency";
import { IGroup } from "@/modules/profile/interfaces/group";
import { ITeam } from "@/modules/profile/interfaces/team";

interface IUser {
  rights?: IGroup[];
}

interface IAuthReducer {
  user?: IUser;
}

interface GetUserByPermissionProps {
  authReducer: IAuthReducer;
  permission: Permissions;
}

export const getUserByPermission = ({
  authReducer,
  permission,
}: GetUserByPermissionProps) => {
  return authReducer?.user?.rights?.some((group: IGroup) =>
    group?.agencies?.some((agency: IAgency) =>
      agency?.teams?.some((team: ITeam) => team?.rights?.includes(permission))
    )
  );
};
